import { render, staticRenderFns } from "./newMaterialLoad.vue?vue&type=template&id=2fcc40e2&scoped=true&"
import script from "./newMaterialLoad.vue?vue&type=script&lang=js&"
export * from "./newMaterialLoad.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialLoad.vue?vue&type=style&index=0&id=2fcc40e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc40e2",
  null
  
)

component.options.__file = "newMaterialLoad.vue"
export default component.exports